export enum StoreDetailsInfo {
    SUFFIX_MORE = "more",
} 